module.exports = __webpack_public_path__ + "static/media/spoonerism-task (7).cdc87fdc.mp3";